import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserStressChange = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [
        ...userColumns,
        { field: 'evaluationDatetime', name: 'Evaluation Date ({tz} time zone)', dataType: 'datetime' },
        { field: 'cognitiveScore', name: 'Cognitive Score', dataType: 'numeric' },
        { field: 'behavioralScore', name: 'Behavioral Score', dataType: 'numeric' },
        { field: 'emotionalScore', name: 'Emotional Score', dataType: 'numeric' },
        { field: 'avoidanceScore', name: 'Avoidance Score', dataType: 'numeric' },
        { field: 'appraisalScore', name: 'Appraisal Score', dataType: 'numeric' },
        { field: 'stressScore', name: 'Stress Score', dataType: 'numeric' },
    ];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.evaluationDatetime),
    //     {
    //         count: true,
    //         avgFields: ['stressScore'],
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Evaluations',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="User Stress Evaluations Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report provides data for financial stress assessments completed
                    by users during the selected time period and filters. The scores
                    measure different dimensions of financial stress and coping
                    strategies. A value from 0 to 4 is low, 5 is moderate, and 6 to 10 is
                    high. For the cumulative score, a value of 0 to 20 is low, 21 to 24 is
                    moderate, and 25 to 40 is high.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Evaluation Date">
                    The date when the stress assessment was conducted.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Cognitive Score">
                    Score measuring how financial stress impacts users thoughts.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Behavioral Score">
                    Score measuring how financial stress affects users actions.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Emotional Score">
                    Score measuring how financial stress influences users feelings.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Avoidance Score">
                    Score measuring how users deal with financial stress by avoiding
                    thinking about it.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Appraisal Score">
                    Score measuring how users deal with financial stress by reviewing the
                    positive and negative impacts.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Stress Score">
                    Overall financial stress score combining all dimensions of stress
                    measurement.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserStressChange;
